export default __webpack_public_path__ + "static/project-slide-7-1248-765-bb7be812d4eebca280c8ec758d5d562d.webp";